export const contaValidator = function (conta) {
  return /^[0-9]{4,12}(-[0-9])?$/.test(conta) 
}